@if (candidates.length > 0) {
	<div class="mb-6 flex items-center justify-between bg-white px-6 text-base">
		<div class="flex-1 font-semibold">{{ previewSummaryTitle }}</div>
		<div class="flex items-center gap-4">
			<button class="flex size-6 items-center justify-center rounded bg-teal text-white" (click)="prevCandidate()">
				<span class="aa-mat-icon">chevron_left</span>
			</button>

			<div class="font-semibold text-violet">
				{{ currentCandidate.name }}
			</div>

			<button class="flex size-6 items-center justify-center rounded bg-teal text-white" (click)="nextCandidate()">
				<span class="aa-mat-icon">chevron_right</span>
			</button>
		</div>
	</div>

	<mat-horizontal-stepper linear #stepperPreview>
		<!-- Step 1: TEM Safety Outcome (hidden for TS5 and TS6) -->
		@if (!isTS5OrTS6) {
			<mat-step [label]="isTS1 ? 'TEM Safety Outcome' : 'TEM Training Effectiveness Ratings by Competency'">
				<div class="pb-6">
					<div class="mb-4 border-y border-[#CFE3FF] py-3 text-sm lg:text-base">
						@if (isTS1) {
							TEM Safety Outcome
						} @else {
							TEM Training Effectiveness Ratings by Competency
						}
					</div>
					<app-cbta-ratings-progress-chart [data]="currentCandidate.manueverData"> </app-cbta-ratings-progress-chart>
				</div>
				@if (isCabinCrew) {
					<button (click)="toggleComments()" class="mt-16 flex items-center gap-2 text-sm text-violet">
						<span>View Comments </span>
						<span class="aa-mat-icon">
							@if (showComment) {
								expand_more
							} @else {
								expand_less
							}
						</span>
					</button>
					@if (showComment) {
						<div class="mt-6">
							<!-- Comments Section -->
							@for (comment of currentCandidate.comments; track comment.ob) {
								<div class="mb-4 border-b border-[#CFE3FF] pb-4 last:border-b-0">
									<div class="text-base font-semibold">
										{{ comment.ob }}
										@if (comment.description) {
											<span class="text-sm font-normal text-gray-500"> · {{ comment.description }}</span>
										}
									</div>

									<!-- Instructor comments per OB -->
									@for (section of comment.sections; track section.role) {
										<div class="mt-4 text-sm">
											<span
												class="text-base font-medium"
												[class.text-green]="section.action === true"
												[class.text-red]="section.action === false"
												[class.text-yellow]="section.rate === -1"
											>
												[{{ section.ob }}]
											</span>
											@if (section.role !== "none" && section.role) {
												<span class="text-base text-violet"> [{{ section.role }}] </span>
											}
											@if (section.remarks) {
												<span
													class="ml-2 text-base font-medium"
													[class.text-green]="(section.rate ?? 0) > 1"
													[class.text-red]="(section.rate ?? 0) <= 1"
													[class.text-yellow]="(section.rate ?? 0) === -1"
												>
													[{{ section.remarks }}]
												</span>
											}
											@if (section.comment) {
												<span class="ml-2">{{ section.comment }}</span>
											}
										</div>
									}
								</div>
							}
						</div>
					}
				} @else {
					<div class="h-10"></div>
				}
				<div class="mt-6 flex items-center justify-between border-t border-[#CFE3FF] py-4">
					<button (click)="close(false)" class="aa-btn" data-size="small" data-variant="tertiary">Back</button>
					@if (isCabinCrew) {
						<button class="aa-btn" data-size="small" data-variant="tertiary" (click)="close(true)">Close</button>
					} @else {
						<button class="aa-btn" data-size="small" data-variant="tertiary" matStepperNext>Next</button>
					}
				</div>
			</mat-step>
		}

		<!-- Step 2: Competency Ratings (shown for all non-cabin crew forms) -->
		@if (!isCabinCrew) {
			<mat-step label="Competency Ratings">
				<div>
					<div class="mb-4 border-y border-[#CFE3FF] py-3 text-sm lg:text-base">Rating per Competency</div>
					<app-cbta-summary-radar-chart
						[labels]="currentCandidate.radarChartLabels"
						[datasets]="currentCandidate.radarChartDatasets"
					>
					</app-cbta-summary-radar-chart>
					<button (click)="toggleComments()" class="flex items-center gap-2 text-sm text-violet">
						<span>View Comments </span>
						<span class="aa-mat-icon">
							@if (showComment) {
								expand_more
							} @else {
								expand_less
							}
						</span>
					</button>
					@if (showComment) {
						<div class="mt-6">
							<!-- Comments Section -->
							@for (comment of currentCandidate.comments; track comment.ob) {
								<div class="mb-4 border-b border-[#CFE3FF] pb-4 last:border-b-0">
									<div class="text-base font-semibold">
										{{ comment.ob }}
										@if (comment.description) {
											<span class="text-sm font-normal text-gray-500"> · {{ comment.description }}</span>
										}
									</div>

									<!-- Instructor comments per OB -->
									@for (section of comment.sections; track section.role) {
										<div class="mt-4 text-sm">
											<span
												class="text-base font-medium"
												[class.text-green]="section.action === true"
												[class.text-red]="section.action === false"
												[class.text-yellow]="section.rate === -1"
											>
												[{{ section.ob }}]
											</span>
											@if (section.role !== "none" && section.role) {
												<span class="text-base text-violet"> [{{ section.role }}] </span>
											}
											@if (section.remarks) {
												<span
													class="ml-2 text-base font-medium"
													[class.text-green]="(section.rate ?? 0) > 1"
													[class.text-red]="(section.rate ?? 0) <= 1"
													[class.text-yellow]="(section.rate ?? 0) === -1"
												>
													[{{ section.remarks }}]
												</span>
											}
											@if (section.comment) {
												<span class="ml-2">{{ section.comment }}</span>
											}
										</div>
									}
								</div>
							}
						</div>
					}
				</div>
				<div class="mt-6 flex items-center justify-between border-t border-[#CFE3FF] py-4">
					@if (!isTS5OrTS6) {
						<button class="aa-btn" data-size="small" data-variant="tertiary" matStepperPrevious>Back</button>
					} @else {
						<div></div>
					}
					<button class="aa-btn" data-size="small" data-variant="tertiary" (click)="close(true)">Close</button>
				</div>
			</mat-step>
		}
	</mat-horizontal-stepper>
}
